import { useState, useEffect, useCallback, useContext } from "react";
import "./ReportList.css";
import { FaCrown, FaTrash } from "react-icons/fa";
import { useNavigate} from "react-router-dom";
import { FaArrowLeftLong } from "react-icons/fa6";
import Loader from "../components/loader";
import { UserContext } from "../context/UserContext";
import { apiFetch } from "../utils/apiFetch";


export default function ReportList({setToggle, onClose}) {
  const navigate = useNavigate();
 

  const { user, loading: userLoading } = useContext(UserContext);
  const [reports, setReports] = useState([]);
  const [loadingReports, setLoadingReports] = useState(true);
  const [deleteTargetId, setDeleteTargetId] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const isBypassUser = user?.email?.trim().toLowerCase() === "marsmatedemo@gmail.com" || window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";

  const handleDeleteConfirm = async () => {
    if (!deleteTargetId) return;
    setDeleting(true);
    const url = `${process.env.REACT_APP_BACKEND_URL}/idea-validation/delete-report/${deleteTargetId}`;
    console.log("[DELETE CONFIRM] Fetching URL:", url);
    try {
      const res = await fetch(url, {
        method: "DELETE",
        credentials: "include"
      });
      console.log("[DELETE CONFIRM] Response status:", res.status);
      const data = await res.json();
      console.log("[DELETE CONFIRM] Response data:", data);
      if (data.success) {
        setReports(prev => prev.filter(r => String(r.id) !== String(deleteTargetId)));
      } else {
        console.error("[DELETE CONFIRM] Deletion failed:", data.error || data.message);
        alert(`Deletion failed: ${data.error || data.message || "Unknown error"}`);
      }
    } catch (err) {
      console.error("[DELETE CONFIRM] Network error during deletion:", err);
      alert(`Network error during deletion: ${err.message}`);
    } finally {
      setDeleting(false);
      setDeleteTargetId(null);
    }
  };

  /* ================= FETCH REPORTS ================= */
  const fetchReports = useCallback(async (userId) => {
    try {
      const res = await apiFetch(
        `/idea-validation/report-list/${userId}`
      );
      const data = await res.json();

      if (data?.success) {
        setReports(data.reports || []);
      } else {
        setReports([]);
      }
    } catch (err) {
      console.error("Error fetching reports:", err);
      setReports([]);
    } finally {
      setLoadingReports(false);
    }
  }, []);

  /* ================= LOAD ON USER READY ================= */
  useEffect(() => {
    localStorage.removeItem("proButtonActive");
    localStorage.removeItem("premiumButtonActive");
    localStorage.removeItem("mindproButtonActive");
    localStorage.removeItem("mindpremiumButtonActive");
    localStorage.removeItem("mindReports")

    if (!userLoading && user?.user_id) {
      fetchReports(user.user_id);
    } else if (!userLoading && !user) {
      setLoadingReports(false);
    }
  }, [user, userLoading, fetchReports]);

  /* ================= GLOBAL LOADING ================= */
  if (userLoading || loadingReports) {
    // URL tokens check (Sidebar navigation check)
    

    return (
      <div className="report-main-container">
        <Loader />
      </div>
    );
  }

  /* ================= EMPTY STATE ================= */
  if (reports.length === 0) {
    return (
      <div className="report-main-container">
        <div className="no-reports-con">
          No Reports Generated. Fill Idea Validation Form In Home To Generate Report
        </div>
      </div>
    );
  }

  // Helper for Report Subscription Navigation
  const goToSubscription = (report, type) => {
     setToggle(false)
      onClose()
    
    if (type === "A") {
      localStorage.setItem("proButtonActive", "true");
      localStorage.setItem("payingReportType", "A");
    } else {
      localStorage.setItem("premiumButtonActive", "true");
      localStorage.setItem("payingReportType", "B");
    }
    
    localStorage.setItem("payingReportId", report.id);
    
    navigate(`/report-subscription`, { state: { report } });
  };

  return (
    <div className="report-main-container-idea">
      <div className="report-heading-container">
        <button className="back-btn-report-list-idea" onClick={() => navigate("/dashboard")}>
          <FaArrowLeftLong size={26} onClick={()=> {
             onClose()
            setToggle(false)
          }}/>
        </button>
        <h2 className="report-heading">Reports</h2>
      </div>

      <div className="report-list-container-main-idea">
        {reports.map((report) => {
          const paidReports = report?.paidReports || [];
          const isPro = paidReports.includes("A");
          const isPremium = paidReports.includes("B");

          return (
            <div className="report-card-main-idea" key={report.id}>
              <div style={{ position: "relative", minHeight: "34px", display: "flex", justifyContent: "flex-end", alignItems: "center", gap: "10px", zIndex: 12 }}>
                <div className="created-at" style={{ position: "static" }}>
                  Created At: {new Date(report.createdAt).toLocaleDateString("en-IN", {
                    day: "2-digit", month: "short", year: "numeric",
                  })}
                </div>
                <button 
                  className="report-delete-action-btn" 
                  onClick={() => setDeleteTargetId(report.id)}
                  title="Delete Report"
                >
                  <FaTrash size={12} />
                </button>
              </div>
            
              <div className="company-name">{report.companyName}</div>

              {/* REPORT A */}
              <div className="report-row">
                <div className="left-box">
                  <h3 className="report-title">Report A</h3>
                  <div className="sub-row">
                    <span className="sub-text">Pro</span>
                    <FaCrown className="crown-icon silver" />
                  </div>
                </div>
                <div className="right-box">
                  {isPro || isBypassUser ? (
                    <button className="download-btn-report-idea" onClick={() => {
                        setToggle(false)
                        onClose()
                        localStorage.setItem("reportAccess", true);
                        navigate(`/report`, { state: { reportData: report } });
                    }}>
                      Click Here To Download
                    </button>
                  ) : (
                    <button className="pay-btn" onClick={() => goToSubscription(report, "A")}>
                      Pay ₹ 199/- & See Report
                    </button>
                  )}
                </div>
              </div>

              <hr />

              {/* REPORT B */}
              <div className="report-row">
                <div className="left-box">
                  <h3 className="report-title">Report B</h3>
                  <div className="sub-row">
                    <span className="sub-text1">Premium</span>
                    <FaCrown className="crown-icon gold" />
                  </div>
                </div>
                <div className="middle-box">
                  <span className="score-strong">Score: {report.totalScore || 0} / 600</span>
                </div>
                <div className="right-box">
                  {isPremium || isBypassUser ? (
                    <button className="download-btn-report-idea" onClick={() => {
                       setToggle(false)
                        onClose()
                        localStorage.setItem("reportBAccess", true);
                        navigate(`/report-b`, { state: { reportData: report } });
                    }}>
                      Click Here To Download
                    </button>
                  ) : (
                    <button className="pay-btn" onClick={() => goToSubscription(report, "B")}>
                      Pay ₹ 299/- & See Report
                    </button>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {deleteTargetId && (
        <div className="confirm-delete-overlay">
          <div className="confirm-delete-modal">
            <h3>Confirm Deletion</h3>
            <p>Are you sure you want to delete this report? This action cannot be undone.</p>
            <div className="confirm-delete-actions">
              <button className="confirm-delete-btn" onClick={handleDeleteConfirm} disabled={deleting}>
                {deleting ? "Deleting..." : "Delete"}
              </button>
              <button className="confirm-cancel-btn" onClick={() => setDeleteTargetId(null)} disabled={deleting}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}